import React, { useMemo } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { isUndefined } from 'lodash'
import { EmergencyPowerSettingsModel } from 'src/Libs/emergency-power'
import SettingsBox from 'src/Elements/Data/SettingsBox'
import { TextField } from '@e3dc-react/shell/Elements/InputFields'
import { getNetStatusAsLangCode } from 'src/Libs/emergency-power/utils'
import { Paper, PaperContent } from '@e3dc-react/shell/Elements/Paper'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'

interface Props {
  model: EmergencyPowerSettingsModel | null
}

const EmergencyPowerOverview: React.FC<Props> = ({ model }) => {
  const { t } = useCustomTranslation()

  const emergencyPowerStatus = useMemo<string>(() => {
    if (model && !isUndefined(model.emergencyPowerStatus)) {
      return t(`systemSettings.emergencyPower.emergencyPowerStatus.type${model.emergencyPowerStatus}`)
    }
    return t('systemSettings.emergencyPower.emergencyPowerStatus.unknown')
  }, [model, t])

  return (
    <Paper title={t('systemSettings.emergencyPower.overview.sectionTitle')} dataQa={'emergency-power-settings-config'}>
      <PaperContent sxStyle={{ mt: 2 }}>
        {model ? (
          <>
            <SettingsBox
              data-qa={'settings-box-1'}
              title={t('systemSettings.emergencyPower.overview.netStatus')}
              disabled
              suffix={<TextField value={t(getNetStatusAsLangCode(model))} disabled />}
            />
            <SettingsBox
              data-qa={'settings-box-2'}
              title={t('systemSettings.emergencyPower.overview.emergencyPowerStatus')}
              disabled
              suffix={<TextField value={emergencyPowerStatus} disabled />}
            />
          </>
        ) : (
          <SystemSettingsBlankView />
        )}
      </PaperContent>
    </Paper>
  )
}

export default EmergencyPowerOverview
